<h4 class="nameOfTool">
  {{
    'igo.integration.advanced-map-tool.advanced-swipe.swipe-tool' | translate
  }}
</h4>
<igo-advanced-swipe />
<mat-divider class="advanced-tool-line" />
<h4 class="nameOfTool">
  {{
    'igo.integration.advanced-map-tool.advanced-coordinates.coordinates'
      | translate
  }}
</h4>
<igo-advanced-coordinates />
<mat-divider class="advanced-tool-line" />

<h4 class="nameOfTool">
  {{ 'igo.integration.advanced-map-tool.geolocation.title' | translate }}
</h4>

<div class="igo-input-container">
  <div class="geolocation-slide-toggle-container">
    <mat-slide-toggle
      class="geolocation-option"
      [checked]="tracking$ | async"
      [labelPosition]="'before'"
      (change)="toggleTracking($event.checked)"
    >
      {{ 'igo.integration.advanced-map-tool.geolocation.tracking' | translate }}
    </mat-slide-toggle>

    <mat-slide-toggle
      class="geolocation-option"
      [disabled]="(tracking$ | async) !== true"
      [labelPosition]="'before'"
      [checked]="followPosition$ | async"
      (change)="toggleFollow($event.checked)"
    >
      {{ 'igo.integration.advanced-map-tool.geolocation.follow' | translate }}
    </mat-slide-toggle>
  </div>
</div>
